import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { BillingUiModule } from '@vendasta/billing-ui';
import { VaIconModule } from '@vendasta/uikit';
import baseTranslation from '../assets/i18n/en_devel.json';
import { VaPricingModule } from '../pricing/pricing.module';
import { WEBLATE_COMPONENT_NAME } from '../shared/constants';
import { VaHeaderContainerComponent } from './header-container.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    VaPricingModule,
    VaIconModule,
    MatChipsModule,
    MatButtonModule,
    MatTooltipModule,
    MatCardModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    BillingUiModule,
  ],
  declarations: [VaHeaderContainerComponent],
  exports: [VaHeaderContainerComponent],
})
export class VaHeaderContainerModule {}
